import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { bool, func, number, shape, string } from 'prop-types';
import { Image, Box } from '../../atoms';
import OfferTimer from '../../molecules/OfferTimer';
import TagCoupon from '../../molecules/TagCoupon';
import { Container, ImageContainer, Content, Title, CardButton } from './product-card-horizontal.styles';
import ProductCardShippingTag from '../ProductCard/ShippingTags/shipping-tags';
import ProductCardPrice from '../ProductCardPrice';

function ProductCardHorizontal(_ref) {
  let {
    imgLazyLoading,
    showInCashInfo,
    showDiscount,
    showOfferTimer,
    onView,
    index,
    onClick,
    onMouseDown,
    showDiscountOnlyCashInfo,
    lazyLoadingOffset,
    hidePriceButtonAction,
    showBorder,
    restrictions,
    buttonProps,
    showButton,
    hideOriginalPrice
  } = _ref,
      product = _objectWithoutPropertiesLoose(_ref, ["imgLazyLoading", "showInCashInfo", "showDiscount", "showOfferTimer", "onView", "index", "geoLocTags", "onClick", "onMouseDown", "showDiscountOnlyCashInfo", "lazyLoadingOffset", "hidePriceButtonAction", "showBorder", "restrictions", "buttonProps", "showButton", "hideOriginalPrice"]);

  const {
    title,
    price,
    image,
    installment,
    url,
    titleAs,
    shippingTag,
    imageWidth,
    imageHeight,
    imageAltPrefix,
    hidePrice,
    tagCoupon
  } = product;
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${product.title}` : product.title;
  const displayMode = 'list';
  const hasRestrictions = Boolean((restrictions == null ? void 0 : restrictions.timer_start_date) && (restrictions == null ? void 0 : restrictions.timer_end_date));
  const hasCoupon = Boolean(tagCoupon && (tagCoupon == null ? void 0 : tagCoupon.discountValue));
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
    delay: 1000
  });
  useEffect(() => {
    if (inView) {
      onView(Object.assign({
        index
      }, product));
    }
  }, [inView]);
  const priceData = {
    hiddenPrice: hidePrice,
    displayMode,
    installment,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    price,
    hidePriceButtonAction,
    hideOriginalPrice,
    product
  };
  const hasInstallment = !!(installment != null && installment.amount && installment != null && installment.totalAmount && (installment == null ? void 0 : installment.quantity) > 1);
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    href: url,
    index: index,
    onClick: e => onClick(e, Object.assign({}, product, {
      index
    })),
    onMouseDown: e => onMouseDown(e, Object.assign({}, product, {
      index
    })),
    "data-testid": "product-card-horizontal",
    showBorder: showBorder
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    width: imageWidth,
    height: imageHeight
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    alt: imageAlt,
    width: imageWidth,
    height: imageHeight,
    title: title,
    lazy: imgLazyLoading,
    offset: lazyLoadingOffset
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, {
    as: titleAs,
    "data-testid": "product-title"
  }, title), showOfferTimer && hasRestrictions && !hasCoupon && /*#__PURE__*/React.createElement(OfferTimer, {
    mt: 1,
    mr: 0,
    mb: 0,
    restrictions: {
      timer_start_date: restrictions == null ? void 0 : restrictions.timer_start_date,
      timer_end_date: restrictions == null ? void 0 : restrictions.timer_end_date
    },
    height: "20px",
    fontSize: "14px"
  }), /*#__PURE__*/React.createElement(Box, {
    mt: hasInstallment ? 0 : 2
  }, /*#__PURE__*/React.createElement(ProductCardPrice, priceData)), /*#__PURE__*/React.createElement(TagCoupon, {
    mt: 1,
    tags: tagCoupon
  }), /*#__PURE__*/React.createElement(ProductCardShippingTag, {
    showShippingTags: true,
    shippingTag: {
      cost: shippingTag == null ? void 0 : shippingTag.cost
    },
    price: price
  }), showButton && /*#__PURE__*/React.createElement(CardButton, _extends({}, buttonProps, {
    empty: !(buttonProps != null && buttonProps.onClick),
    onClick: buttonProps == null ? void 0 : buttonProps.onClick,
    uppercase: false,
    "data-testid": "better-offer-btn"
  }), (buttonProps == null ? void 0 : buttonProps.title) || 'Ver oferta')));
}

process.env.NODE_ENV !== "production" ? ProductCardHorizontal.propTypes = {
  imgLazyLoading: bool,
  showInCashInfo: bool,
  showDiscount: bool,
  showDiscountOnlyCashInfo: bool,
  lazyLoadingOffset: number,
  hidePriceButtonAction: func,
  url: string,
  index: number,
  onClick: func,
  onMouseDown: func,
  onView: func,
  buttonProps: shape({
    onClick: func,
    title: string
  }),
  showButton: bool,
  geoLocTags: shape({
    title: string,
    icon: string
  }),
  showBorder: bool,
  showOfferTimer: bool,
  restrictions: shape({}),
  hideOriginalPrice: bool
} : void 0;
ProductCardHorizontal.defaultProps = {
  imgLazyLoading: false,
  showInCashInfo: true,
  showDiscount: false,
  url: '',
  onClick: () => {},
  onMouseDown: () => {},
  onView: () => {},
  geoLocTags: {},
  index: 0,
  showDiscountOnlyCashInfo: true,
  lazyLoadingOffset: 50,
  hidePriceButtonAction: () => {},
  showBorder: false,
  restrictions: {
    timer_end_date: string,
    timer_start_date: string
  },
  showButton: false,
  hideOriginalPrice: false
};
export default ProductCardHorizontal;